interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  invert?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  invert = false,
}: SectionHeadingProps) {
  const centered = align === 'center';
  return (
    <div className={centered ? 'text-center max-w-2xl mx-auto' : 'max-w-2xl'}>
      {eyebrow && (
        <div className={`flex items-center gap-2 mb-3 ${centered ? 'justify-center' : ''}`}>
          <span className={`w-6 h-6 flex items-center justify-center ${invert ? 'text-accent-400' : 'text-primary-600'}`}>
            <i className="ri-seedling-line"></i>
          </span>
          <span
            className={`text-xs md:text-sm font-medium tracking-[0.18em] uppercase ${
              invert ? 'text-accent-400' : 'text-primary-700'
            }`}
          >
            {eyebrow}
          </span>
        </div>
      )}
      <h2
        className={`font-heading text-2xl md:text-4xl font-bold leading-snug ${
          invert ? 'text-white' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-3 text-sm md:text-base leading-relaxed ${
            invert ? 'text-background-300' : 'text-foreground-600'
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}